/*
 * Maison Panoramique : configurateur de mur (élément <mp-configurator>).
 * Dépend de mp-pricing.js (window.MPPricing). Aucune bibliothèque.
 * Règle d'or : le prix affiché est celui de la ligne ajoutée au panier ; sinon, l'ajout est bloqué.
 *
 * Cadrage :
 * - avec la taille physique de l'aperçu (cfg.physical : apercu_largeur_cm × apercu_hauteur_cm), le cadre est
 *   calculé en centimètres. Motif non répété : mur plus grand que l'aperçu → bloqué. Motif répété : échelle fixe,
 *   pas de zoom, l'aperçu se répète en mosaïque ;
 * - sans ces métachamps (repli) : ratio du fichier et largeur / hauteur maximales du catalogue.
 */
(function () {
  'use strict';
  if (customElements.get('mp-configurator')) return;

  var SVG_NS = 'http://www.w3.org/2000/svg';
  var WALL_KEY = 'mp:mur'; // sessionStorage : dernières mesures valides saisies par le client (28/10)
  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function $(root, sel) { return root.querySelector(sel); }
  function $$(root, sel) { return Array.prototype.slice.call(root.querySelectorAll(sel)); }
  function fmtCm(n) {
    var r = Math.round(n * 10) / 10;
    return String(r).replace('.', ',');
  }
  function pct(n) { return Math.round(n * 100) + ' %'; }
  /** Nombre français sans symbole : 33750 centimes → « 337,50 » ; 4500 → « 45 » (compact). */
  function num(cents, compact) {
    var n = (Number(cents) / 100).toFixed(2).split('.');
    var i = n[0].replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
    return compact && n[1] === '00' ? i : i + ',' + n[1];
  }
  function m2(v) { return String(Math.round(v * 100) / 100).replace('.', ','); }
  function meters(cm) { return String(Math.round(cm) / 100).replace('.', ','); }
  /** Nom de propriété de ligne visible : suivi d'une espace insécable, Shopify ajoute « : » (« Motif : … »). */
  function K(name) { return name + '\u00a0'; }
  function fill(tpl, map) {
    return String(tpl || '').replace(/\{(\w+)\}/g, function (m, k) { return map[k] != null ? map[k] : m; });
  }

  function addBusinessDays(date, days) {
    var d = new Date(date.getTime());
    var added = 0;
    while (added < days) {
      d.setDate(d.getDate() + 1);
      var day = d.getDay();
      if (day !== 0 && day !== 6) added++;
    }
    return d;
  }

  class MpConfigurator extends HTMLElement {
    connectedCallback() {
      if (this._ready) return;
      var P = window.MPPricing;
      if (!P) {
        // mp-pricing.js est chargé avec defer avant ce fichier ; sécurité si l'ordre change.
        window.addEventListener('DOMContentLoaded', this.connectedCallback.bind(this), { once: true });
        return;
      }
      this._ready = true;
      this.P = P;
      try {
        this.cfg = JSON.parse($(this, '[data-mp-config]').textContent);
      } catch (e) {
        console.error('[mp-configurator] configuration illisible', e);
        return;
      }
      var c = this.cfg;
      var ph = c.physical || {};
      this.physical = Number(ph.widthCm) > 0 && Number(ph.heightCm) > 0;
      this.repeat = this.physical && !!ph.repeat;
      this.state = {
        width: c.defaults.width,
        height: c.defaults.height,
        material: c.defaults.material,
        tint: c.defaults.tint,
        strip: 'equal',
        spare: false,
        cx: 0.5,
        cy: 0.5,
        zoom: 1,
        touched: false,
        zoomHitMax: false,
      };
      this.el = {
        width: $(this, '[data-input="width"]'),
        height: $(this, '[data-input="height"]'),
        errWidth: $(this, '[data-error="width"]'),
        errHeight: $(this, '[data-error="height"]'),
        fitError: $(this, '[data-fit-error]'),
        obstacles: $(this, '[data-input="obstacles"]'),
        stage: $(this, '[data-stage]'),
        stageImg: $(this, '[data-stage-img]'),
        frame: $(this, '[data-frame]'),
        seams: $(this, '.mp-stage__seams'),
        zoom: $(this, '.mp-zoom'),
        zoomRange: $(this, '[data-zoom-range]'),
        resNote: $(this, '[data-resolution-note]'),
        plan: $(this, '[data-plan]'),
        planText: $(this, '[data-plan-text]'),
        total: $(this, '[data-total]'),
        detail: $(this, '[data-price-detail]'),
        surface: $(this, '[data-billed]'),
        minimum: $(this, '[data-minimum]'),
        spare: $(this, '[data-input="spare"]'),
        block: $(this, '[data-block]'),
        blockText: $(this, '[data-block-text]'),
        halfWall: $(this, '[data-half-wall]'),
        compat: $(this, '[data-compat]'),
        compatList: $(this, '[data-compat-list]'),
        add: $(this, '[data-add]'),
        addLabel: $(this, '[data-add-label]'),
        status: $(this, '[data-status]'),
        delivery: $(this, '[data-delivery]'),
        deliveryText: $(this, '[data-delivery-text]'),
      };
      var tintFixed = $(this, '[data-input="tint-fixed"]');
      if (tintFixed) this.state.tint = tintFixed.value;
      var checkedMat = $(this, '[data-input="material"]:checked');
      if (checkedMat) this.state.material = checkedMat.value;
      var checkedTint = $(this, '[data-input="tint"]:checked');
      if (checkedTint) this.state.tint = checkedTint.value;
      if (this.repeat) this.classList.add('is-repeat');
      if (this.repeat && this.el.stage) this.setupRepeatStage();

      this.sticky = document.querySelector('[data-sticky-for="' + this.id + '"]');
      this.dimsValid = true;
      this.restoreWall();
      this.bind();
      this.renderDelivery();
      this.update({ rebuildPlan: true });
      this.setupSticky();
    }

    /** Reprend les mesures saisies sur une fiche précédente (même onglet). Sans saisie ou sans stockage : rien. */
    restoreWall() {
      var saved = null;
      try {
        saved = this.P.parseSavedWall(window.sessionStorage.getItem(WALL_KEY), this.cfg.limits);
      } catch (e) { saved = null; }
      if (!saved || !this.el.width || !this.el.height) return;
      this.state.width = saved.width;
      this.state.height = saved.height;
      this.el.width.value = String(saved.width);
      this.el.height.value = String(saved.height);
    }

    saveWall() {
      try {
        window.sessionStorage.setItem(WALL_KEY, JSON.stringify({ w: this.state.width, h: this.state.height }));
      } catch (e) { /* stockage indisponible : sans effet */ }
    }

    art() {
      var a = this.cfg.art || {};
      return (this.state.tint === 'light' ? a.light : a.dark) || a.dark || a.light || null;
    }

    rate() {
      var m = this.material();
      return m ? Number(m.rate) : 0;
    }

    material() {
      var code = this.state.material;
      return (this.cfg.materials || []).filter(function (m) { return m.code === code; })[0];
    }

    /** Hauteur maximale du motif (taille physique de l'aperçu, sinon catalogue). 0 = pas de limite connue. */
    maxHeight() {
      if (this.physical) return this.repeat ? 0 : Number(this.cfg.physical.heightCm);
      return Number(this.cfg.maxPrintHeightCm) || 0;
    }

    maxWidth() {
      if (this.physical) return this.repeat ? 0 : Number(this.cfg.physical.widthCm);
      return Number(this.cfg.maxPrintWidthCm) || 0;
    }

    bind() {
      var self = this;
      var onDims = function (ev) { self.readDims(ev.type === 'change'); };
      [this.el.width, this.el.height].forEach(function (input) {
        if (!input) return;
        input.addEventListener('input', onDims);
        input.addEventListener('change', onDims);
      });
      $$(this, '[data-input="material"]').forEach(function (r) {
        r.addEventListener('change', function () { self.state.material = r.value; self.state.touched = true; self.update({}); });
      });
      $$(this, '[data-input="tint"]').forEach(function (r) {
        r.addEventListener('change', function () { self.state.tint = r.value; self.state.touched = true; self.swapArt(); self.update({ rebuildPlan: true }); });
      });
      if (this.el.spare) this.el.spare.addEventListener('change', function () {
        self.state.spare = self.el.spare.checked;
        self.update({ rebuildPlan: true });
      });
      if (this.el.zoomRange) {
        this.el.zoomRange.addEventListener('input', function () {
          self.state.zoom = Number(self.el.zoomRange.value) / 100;
          self.state.touched = true;
          self.update({});
        });
      }
      $$(this, '[data-zoom]').forEach(function (b) {
        b.addEventListener('click', function () { self.nudgeZoom(Number(b.dataset.zoom) * 0.1); });
      });
      if (this.el.halfWall) this.el.halfWall.addEventListener('click', function () {
        // demi-mur : la hauteur du mur passe à la hauteur maximale du motif ; le haut du mur reste libre
        self.el.height.value = String(Math.floor(self.maxHeight()));
        self.readDims(true, { save: false }); // hauteur du motif, pas celle du mur : non gardée pour les autres fiches
        self.el.height.focus();
      });
      var recenter = $(this, '[data-recenter]');
      if (recenter) recenter.addEventListener('click', function () {
        self.state.cx = 0.5; self.state.cy = 0.5; self.state.zoom = 1; self.state.zoomHitMax = false; self.update({});
      });
      if (this.el.add) this.el.add.addEventListener('click', function () { self.addToCart(); });
      $$(this, '[data-add-sample]').forEach(function (b) {
        b.addEventListener('click', function () { self.addSample(b.dataset.addSample, b); });
      });
      this.bindDrag();
      if (window.ResizeObserver && this.el.stage) {
        this._ro = new ResizeObserver(function () { self.renderFrame(); });
        this._ro.observe(this.el.stage);
      }
    }

    readDims(commit, opts) {
      var w = this.el.width.value;
      var h = this.el.height.value;
      // Une saisie que le navigateur juge invalide (« 300,5 » dans un champ numérique) arrive vide : on la refuse.
      if (w === '' && this.el.width.validity && this.el.width.validity.badInput) w = 'x';
      if (h === '' && this.el.height.validity && this.el.height.validity.badInput) h = 'x';
      var errors = this.P.validateDimensions(w, h, this.cfg.limits);
      var errW = errors.filter(function (e) { return e.field === 'width'; })[0];
      var errH = errors.filter(function (e) { return e.field === 'height'; })[0];
      // Les erreurs s'affichent à la validation du champ ; pendant la frappe, on efface celles qui sont réglées.
      if (commit) {
        this.showError(this.el.width, this.el.errWidth, errW);
        this.showError(this.el.height, this.el.errHeight, errH);
      } else {
        if (!errW) this.showError(this.el.width, this.el.errWidth, null);
        if (!errH) this.showError(this.el.height, this.el.errHeight, null);
      }
      this.dimsValid = errors.length === 0;
      this.state.touched = true;
      if (this.dimsValid) {
        this.state.width = Math.round(Number(w));
        this.state.height = Math.round(Number(h));
        if (!opts || opts.save !== false) this.saveWall();
        this.update({ rebuildPlan: true });
      } else {
        this.renderInvalid();
        this.refreshCta();
      }
    }

    showError(input, slot, err) {
      if (!slot) return;
      var msg = '';
      var t = this.cfg.text;
      if (err) {
        var isW = err.field === 'width';
        if (err.code === 'missing') msg = isW ? t.errWidthEmpty : t.errHeightEmpty;
        else if (err.code === 'not_integer') msg = t.errInteger;
        else if (err.code === 'too_small') msg = t.errTooSmall;
        else if (err.code === 'too_large') msg = isW ? fill(t.errWidthGlobal, { largeur_max_cm: err.limit }) : fill(t.errHeightMax, { hauteur_max_cm: err.limit });
      }
      slot.textContent = msg;
      input.setAttribute('aria-invalid', msg ? 'true' : 'false');
    }

    /** Saisie invalide : ni total ni plan d'un autre mur ; le bloc d'achat dit quoi corriger. */
    renderInvalid() {
      var t = this.cfg.text;
      this.el.total.textContent = '—';
      this.markPriceUnavailable(false);
      this.el.detail.textContent = '';
      this.el.surface.textContent = '';
      this.el.minimum.hidden = true;
      if (this.el.planText) this.el.planText.textContent = t.planInvalid;
      if (this.el.plan) this.el.plan.classList.add('is-stale');
      this.classList.add('is-invalid');
      if (this.sticky) {
        var st = this.sticky.querySelector('[data-sticky-total]');
        if (st) st.textContent = '—';
      }
    }

    /* ---------- Calcul et affichage ---------- */

    stripPlan() {
      return this.P.stripPlan(this.state.width, this.state.height);
    }

    /** Surface du lé de rechange (cm²) : un lé de la largeur d'un lé du mur, sur toute la hauteur du mur. */
    spareCm2() {
      if (!this.state.spare) return 0;
      var st = this.stripPlan();
      if (!st) return 0;
      return Math.round(st.list[0].widthCm * this.state.height);
    }

    update(opts) {
      var s = this.state;
      var c = this.cfg;
      this.classList.remove('is-invalid');
      if (this.el.plan) this.el.plan.classList.remove('is-stale');
      this.plan = this.P.planCart({
        widthCm: s.width,
        heightCm: s.height,
        rateEurPerM2: this.rate(),
        minimumEur: c.minimumEur,
        stepDm2: c.stepDm2,
        stripWidthCm: s.strip,
        extraCm2: this.spareCm2(),
        material: s.material,
        variants: c.custom || [],
      });
      this.limits = this.computeLimits();
      this.applyFrame();
      this.renderPrice();
      this.renderFrame();
      this.renderPlan(opts && opts.rebuildPlan);
      this.renderPlanFit();
      this.refreshCta();
    }

    /** Mur trop grand pour ce motif : pas de plan des lés présenté comme valable. */
    renderPlanFit() {
      if (!this.el.plan) return;
      var infeasible = !!(this.limits && !this.limits.feasible);
      this.el.plan.hidden = infeasible;
      if (infeasible && this.el.planText) this.el.planText.textContent = this.cfg.text.planInfeasible || '';
    }

    computeLimits() {
      if (this.physical) {
        return this.P.physicalFrame({
          wallWidthCm: this.state.width,
          wallHeightCm: this.state.height,
          artWidthCm: Number(this.cfg.physical.widthCm),
          artHeightCm: Number(this.cfg.physical.heightCm),
          repeat: this.repeat,
        });
      }
      var art = this.art();
      if (!art || !art.w || !art.h) return null;
      return this.P.frameLimits({
        wallWidthCm: this.state.width,
        wallHeightCm: this.state.height,
        imageRatio: art.w / art.h,
        maxPrintWidthCm: Number(this.cfg.maxPrintWidthCm) || 0,
        maxPrintHeightCm: Number(this.cfg.maxPrintHeightCm) || 0,
      });
    }

    /** Taille de la scène en nombre d'aperçus (1 × 1, sauf motif répété : mosaïque autour du mur). */
    viewTiles(fw, fh) {
      if (!this.repeat) return { vw: 1, vh: 1 };
      return { vw: Math.max(2, Math.ceil(fw) + 1), vh: fh <= 1 ? 1 : Math.ceil(fh) + 1 };
    }

    clampIn(frame, vw, vh) {
      var fw = Math.min(vw, Math.max(0, frame.fw));
      var fh = Math.min(vh, Math.max(0, frame.fh));
      return {
        x: Math.min(vw - fw, Math.max(0, frame.x)),
        y: Math.min(vh - fh, Math.max(0, frame.y)),
        fw: fw,
        fh: fh,
      };
    }

    applyFrame() {
      var L = this.limits;
      if (!L) { this.frame = null; return; }
      var s = this.state;
      var maxZoom = Math.max(1, L.maxZoom);
      if (s.zoom > maxZoom) s.zoom = maxZoom;
      if (s.zoom < 1) s.zoom = 1;
      var fw = L.maxFw / s.zoom;
      var fh = L.frameHeightFraction(fw);
      if (!this.repeat) { fw = Math.min(1, fw); fh = Math.min(1, fh); }
      var view = this.viewTiles(fw, fh);
      this.view = view;
      // cx, cy : centre du cadre en fraction de la scène
      var f = this.clampIn({ x: s.cx * view.vw - fw / 2, y: s.cy * view.vh - fh / 2, fw: fw, fh: fh }, view.vw, view.vh);
      s.cx = (f.x + f.fw / 2) / view.vw;
      s.cy = (f.y + f.fh / 2) / view.vh;
      this.frame = f;
      if (this.repeat) this.sizeRepeatStage(view);
      var zoomable = maxZoom > 1.001 && !this.repeat;
      if (this.el.zoom) this.el.zoom.classList.toggle('is-inactive', !zoomable);
      if (this.el.zoomRange) {
        this.el.zoomRange.max = String(Math.round(maxZoom * 100));
        this.el.zoomRange.value = String(Math.round(s.zoom * 100));
        this.el.zoomRange.disabled = !zoomable;
      }
      if (this.el.resNote) {
        var t = this.cfg.text;
        var note = '';
        if (L.feasible) {
          if (!this.physical && L.maxFw < 0.45 && s.touched) note = t.errCropTight;
          else if (s.zoomHitMax && zoomable && s.zoom >= maxZoom - 0.001) note = t.zoomLimited;
        }
        this.el.resNote.hidden = !note;
        this.el.resNote.textContent = note;
      }
    }

    /** Pourquoi ce mur n'est pas faisable avec ce motif : trop large, trop haut, ou mur trop allongé (repli). */
    infeasibleMessage() {
      var t = this.cfg.text;
      var maxW = this.maxWidth();
      var maxH = this.maxHeight();
      var vars = {
        largeur_max_cm: Math.floor(maxW), largeur_max_m: meters(maxW),
        hauteur_max_cm: Math.floor(maxH), hauteur_max_m: meters(maxH),
        largeur: this.state.width, hauteur: this.state.height,
      };
      var issue = this.P.fitIssue(this.state.width, this.state.height, maxW, maxH);
      if (issue === 'both' && t.errBothMax) return fill(t.errBothMax, vars);
      if (issue === 'both' || issue === 'width') return fill(t.errWidthMax, vars);
      if (issue === 'height') return fill(t.errArtHeightMax, vars);
      return t.errCropTight;
    }

    // Surface du mur (toujours le mur seul), puis la surface facturée à part quand un lé de rechange
    // ou l'arrondi la rend différente. Le prix n'en dépend pas.
    surfaceText(q) {
      var t = this.cfg.text;
      var vars = { surface: m2(q.wallM2), surface_facturee: m2(q.billedM2) };
      var key = t.billedNote;
      if (q.billedM2 > q.surfaceM2 + 1e-9) key = t.roundingNote;
      else if (q.extraCm2 > 0) key = t.billedSpareNote;
      var txt = fill(key, vars);
      if (q.extraCm2 > 0) txt += ' ' + fill(t.spareIncluded, { surface_le: m2(q.extraCm2 / 10000) });
      return txt;
    }

    renderPrice() {
      var P = this.P;
      var q = this.plan && this.plan.quote;
      if (!q) return;
      var t = this.cfg.text;
      if (this.limits && !this.limits.feasible) {
        // mur refusé pour ce motif : aucun prix au-dessus du bouton, mais un texte qui dit pourquoi (29/10)
        this.el.total.textContent = t.priceUnavailable || '—';
        this.markPriceUnavailable(!!t.priceUnavailable);
        this.el.detail.textContent = '';
        this.el.surface.textContent = '';
        this.el.minimum.hidden = true;
        if (this.sticky) {
          var stx = this.sticky.querySelector('[data-sticky-total]');
          if (stx) stx.textContent = '—';
        }
        return;
      }
      var total = P.formatEuros(q.totalCents);
      this.el.total.textContent = total;
      this.markPriceUnavailable(false);
      if (this.plan.line && this.plan.line.reason === 'on_request') {
        this.el.detail.textContent = t.priceIndicative;
        this.el.surface.textContent = this.surfaceText(q);
        this.el.minimum.hidden = true;
        if (this.sticky) {
          var sto = this.sticky.querySelector('[data-sticky-total]');
          if (sto) sto.textContent = total;
        }
        return;
      }
      this.el.detail.textContent = q.minimumApplied ? t.detailMinimum : fill(t.detail, { prix_m2: num(q.rateCents, true) });
      var surface = m2(q.wallM2); // surface du mur seul, jamais augmentée du lé de rechange
      if (q.minimumApplied) {
        // Montant facturé dit clairement (minimum), et ce que ce minimum couvre : jamais un « soit 171 € » ambigu.
        var covered = Math.floor((q.minimumCents / q.rateCents) * 10) / 10;
        this.el.surface.textContent = '';
        this.el.minimum.hidden = false;
        this.el.minimum.textContent = fill(t.minimumNote, {
          surface: surface,
          prix_minimum: num(q.minimumCents, true),
          surface_couverte: m2(covered),
        });
      } else {
        this.el.minimum.hidden = true;
        this.el.surface.textContent = this.surfaceText(q);
      }
      if (this.sticky) {
        var st = this.sticky.querySelector('[data-sticky-total]');
        if (st) st.textContent = total;
      }
    }

    /** Texte « prix indisponible » à la place du montant : même ligne, en corps de texte (29/10). */
    markPriceUnavailable(on) {
      var line = this.el.total && this.el.total.closest('.mp-buy__total');
      if (line) line.classList.toggle('is-unavailable', on);
    }

    refreshCta() {
      var t = this.cfg.text;
      var infeasible = this.dimsValid && this.limits && !this.limits.feasible;
      var ok = this.dimsValid && this.plan && this.plan.line && this.plan.line.ok && !infeasible;
      var msg = '';
      var halfWall = false;
      var compat = false;
      if (!this.dimsValid) msg = t.errDims;
      else if (infeasible) {
        msg = this.infeasibleMessage();
        halfWall = this.limits.tooTall && !this.limits.tooWide && this.maxHeight() >= 50;
        compat = true;
      } else if (this.plan && this.plan.line && !this.plan.line.ok) {
        var reason = this.plan.line.reason;
        msg = reason === 'on_request' ? t.onRequest : reason === 'price_mismatch' ? t.blockedPrice : t.blockedCatalog;
        if (this.plan.line.reason === 'price_mismatch') console.error('[mp-configurator] prix du catalogue différent', this.plan.line);
      }
      this.el.add.disabled = !ok;
      this.el.add.setAttribute('aria-disabled', ok ? 'false' : 'true');
      this.renderBlock(msg, halfWall, compat);
      // le format dépassé se lit aussi juste sous les champs de mesure (le bloc au-dessus du bouton garde les issues)
      if (this.el.fitError) this.el.fitError.textContent = infeasible ? msg : '';
      this.blockedMsg = msg;
      this.refreshSticky(ok);
    }

    /** Message de blocage AU-DESSUS du bouton, avec des issues concrètes. */
    renderBlock(msg, halfWall, compat) {
      var b = this.el.block;
      if (!b) return;
      b.hidden = !msg;
      if (!msg) return;
      this.el.blockText.textContent = msg;
      if (this.el.halfWall) {
        this.el.halfWall.hidden = !halfWall;
        if (halfWall) this.el.halfWall.textContent = fill(this.cfg.text.halfWall, { hauteur_max_cm: Math.floor(this.maxHeight()) });
      }
      if (this.el.compat) {
        this.el.compat.hidden = !compat;
        if (compat) this.renderCompat();
      }
    }

    /** Jusqu'à 3 motifs du catalogue qui couvrent ce mur (calculés d'après leurs limites). */
    renderCompat() {
      var list = this.el.compatList;
      if (!list) return;
      var P = this.P;
      var w = this.state.width;
      var h = this.state.height;
      var picks = P.compatibleMotifs(this.cfg.motifs, w, h, { excludeId: this.cfg.product.id, themes: this.cfg.themes || [], limit: 3 });
      list.replaceChildren();
      picks.forEach(function (m) {
        var li = document.createElement('li');
        var a = document.createElement('a');
        a.href = m.url;
        a.className = 'mp-inline-link';
        a.textContent = m.title;
        li.appendChild(a);
        list.appendChild(li);
      });
      list.hidden = picks.length === 0;
    }

    setStatus(text, kind) {
      this.el.status.textContent = text || '';
      this.el.status.dataset.kind = kind || '';
    }

    /* ---------- Cadrage ---------- */

    swapArt() {
      var art = this.art();
      if (!art) return;
      if (this.el.stageImg) {
        this.el.stageImg.src = art.src;
        this.el.stageImg.width = art.w;
        this.el.stageImg.height = art.h;
      }
      if (this.repeat && this.el.stage) this.el.stage.style.backgroundImage = 'url("' + art.src + '")';
    }

    /** Motif répété : la scène montre l'aperçu en mosaïque (fond CSS répété) au lieu d'une image unique. */
    setupRepeatStage() {
      var art = this.art();
      var st = this.el.stage;
      st.classList.add('mp-stage--repeat');
      if (art) st.style.backgroundImage = 'url("' + art.src + '")';
      if (this.el.stageImg) this.el.stageImg.hidden = true;
    }

    sizeRepeatStage(view) {
      var ph = this.cfg.physical;
      var st = this.el.stage;
      st.style.aspectRatio = (view.vw * Number(ph.widthCm)) + ' / ' + (view.vh * Number(ph.heightCm));
      st.style.backgroundSize = (100 / view.vw) + '% ' + (100 / view.vh) + '%';
    }

    renderFrame() {
      var f = this.frame;
      var frameEl = this.el.frame;
      if (!frameEl) return;
      if (!f || !this.el.stage || (!this.el.stageImg && !this.repeat)) { frameEl.hidden = true; return; }
      var view = this.view || { vw: 1, vh: 1 };
      frameEl.hidden = false;
      var rect = this.el.stage.getBoundingClientRect();
      frameEl.style.width = (f.fw / view.vw * 100) + '%';
      frameEl.style.height = (f.fh / view.vh * 100) + '%';
      frameEl.style.transform = 'translate(' + (f.x / view.vw * rect.width).toFixed(2) + 'px,' + (f.y / view.vh * rect.height).toFixed(2) + 'px)';
      var st = this.stripPlan();
      var stepPct = st ? Math.min(100, (st.list[0].widthCm / this.state.width) * 100) : 100;
      if (this.el.seams) {
        this.el.seams.style.backgroundSize = stepPct.toFixed(4) + '% 100%';
        // le premier lé déborde du mur de la marge de coupe : les joints sont décalés d'autant vers la gauche
        var seamPx = st ? -((st.marginCm || 0) / this.state.width) * (f.fw / view.vw) * rect.width : 0;
        this.el.seams.style.backgroundPosition = seamPx.toFixed(2) + 'px 0';
      }
      frameEl.setAttribute('aria-valuetext',
        'Cadre à ' + pct((f.x + f.fw / 2) / view.vw) + ' depuis la gauche, ' + pct((f.y + f.fh / 2) / view.vh) + ' depuis le haut' +
        (this.repeat ? '' : ', zoom ' + this.state.zoom.toFixed(1).replace('.', ',')));
    }

    bindDrag() {
      var self = this;
      var frame = this.el.frame;
      if (!frame) return;
      var drag = null;
      frame.addEventListener('pointerdown', function (e) {
        if (!self.frame || e.button > 0) return;
        e.preventDefault();
        frame.setPointerCapture(e.pointerId);
        var rect = self.el.stage.getBoundingClientRect();
        drag = { id: e.pointerId, sx: e.clientX, sy: e.clientY, x: self.frame.x, y: self.frame.y, w: rect.width, h: rect.height };
        frame.classList.add('is-dragging');
      });
      frame.addEventListener('pointermove', function (e) {
        if (!drag || e.pointerId !== drag.id) return;
        var view = self.view || { vw: 1, vh: 1 };
        var f = self.clampIn({
          x: drag.x + ((e.clientX - drag.sx) / drag.w) * view.vw,
          y: drag.y + ((e.clientY - drag.sy) / drag.h) * view.vh,
          fw: self.frame.fw,
          fh: self.frame.fh,
        }, view.vw, view.vh);
        self.state.cx = (f.x + f.fw / 2) / view.vw;
        self.state.cy = (f.y + f.fh / 2) / view.vh;
        self.state.touched = true;
        self.frame = f;
        if (!self._raf) {
          self._raf = requestAnimationFrame(function () {
            self._raf = null;
            self.renderFrame();
            self.positionPlanImage();
            self.refreshSticky(!self.el.add.disabled);
          });
        }
      });
      var end = function (e) {
        if (!drag || (e.pointerId !== undefined && e.pointerId !== drag.id)) return;
        drag = null;
        frame.classList.remove('is-dragging');
      };
      frame.addEventListener('pointerup', end);
      frame.addEventListener('pointercancel', end);
      frame.addEventListener('keydown', function (e) {
        var step = e.shiftKey ? 0.05 : 0.01;
        var handled = true;
        switch (e.key) {
          case 'ArrowLeft': self.state.cx -= step; break;
          case 'ArrowRight': self.state.cx += step; break;
          case 'ArrowUp': self.state.cy -= step; break;
          case 'ArrowDown': self.state.cy += step; break;
          case '+': case '=': self.nudgeZoom(0.1); return e.preventDefault();
          case '-': case '_': self.nudgeZoom(-0.1); return e.preventDefault();
          default: handled = false;
        }
        if (handled) {
          e.preventDefault();
          self.state.touched = true;
          self.update({});
        }
      });
    }

    nudgeZoom(delta) {
      if (this.repeat) return;
      var max = this.limits ? Math.max(1, this.limits.maxZoom) : 1;
      this.state.zoomHitMax = delta > 0 && this.state.zoom + delta > max + 0.001;
      this.state.zoom = Math.round((this.state.zoom + delta) * 100) / 100;
      this.state.touched = true;
      this.update({});
    }

    /* ---------- Plan des lés (SVG) ---------- */

    renderPlan(rebuild) {
      var q = this.plan && this.plan.quote;
      var st = q && q.strips;
      if (!st || !this.el.plan) return;
      var W = this.state.width;
      var H = this.state.height;
      if (rebuild || !this._svg) {
        var svg = document.createElementNS(SVG_NS, 'svg');
        svg.setAttribute('viewBox', '0 0 ' + W + ' ' + H);
        svg.setAttribute('preserveAspectRatio', 'xMidYMid meet');
        svg.setAttribute('class', 'mp-plan__svg');
        var defs = document.createElementNS(SVG_NS, 'defs');
        var clip = document.createElementNS(SVG_NS, 'clipPath');
        var clipId = 'mp-plan-clip-' + this.dataset.sectionId;
        clip.setAttribute('id', clipId);
        var cr = document.createElementNS(SVG_NS, 'rect');
        cr.setAttribute('width', W); cr.setAttribute('height', H);
        clip.appendChild(cr); defs.appendChild(clip); svg.appendChild(defs);

        var bg = document.createElementNS(SVG_NS, 'rect');
        bg.setAttribute('width', W); bg.setAttribute('height', H); bg.setAttribute('class', 'mp-plan__wall');
        svg.appendChild(bg);

        var art = this.art();
        this._planImg = null;
        this._planPattern = null;
        if (art && this.frame) {
          var g = document.createElementNS(SVG_NS, 'g');
          g.setAttribute('clip-path', 'url(#' + clipId + ')');
          if (this.repeat) {
            // motif répété : l'aperçu en mosaïque, à sa taille physique (cm), décalé selon le cadre
            var pat = document.createElementNS(SVG_NS, 'pattern');
            pat.setAttribute('id', 'mp-plan-pat-' + this.dataset.sectionId);
            pat.setAttribute('patternUnits', 'userSpaceOnUse');
            pat.setAttribute('width', this.cfg.physical.widthCm);
            pat.setAttribute('height', this.cfg.physical.heightCm);
            var pimg = document.createElementNS(SVG_NS, 'image');
            pimg.setAttribute('href', art.src);
            pimg.setAttribute('width', this.cfg.physical.widthCm);
            pimg.setAttribute('height', this.cfg.physical.heightCm);
            pimg.setAttribute('preserveAspectRatio', 'none');
            pat.appendChild(pimg);
            defs.appendChild(pat);
            var fillRect = document.createElementNS(SVG_NS, 'rect');
            fillRect.setAttribute('width', W); fillRect.setAttribute('height', H);
            fillRect.setAttribute('fill', 'url(#mp-plan-pat-' + this.dataset.sectionId + ')');
            g.appendChild(fillRect);
            this._planPattern = pat;
          } else {
            var img = document.createElementNS(SVG_NS, 'image');
            img.setAttribute('href', art.src);
            img.setAttribute('preserveAspectRatio', 'none');
            g.appendChild(img);
            this._planImg = img;
          }
          svg.appendChild(g);
        }
        // tous les lés sont numérotés ; le premier commence dans la marge de coupe, à gauche du mur
        var baseFont = Math.max(8, Math.min(60 * 0.32, H * 0.09));
        var x0 = -(st.marginCm || 0);
        for (var i = 0; i < st.count; i++) {
          var wPart = st.list[i].widthCm;
          if (i > 0) {
            var line = document.createElementNS(SVG_NS, 'line');
            line.setAttribute('x1', x0); line.setAttribute('x2', x0);
            line.setAttribute('y1', 0); line.setAttribute('y2', H);
            line.setAttribute('class', 'mp-plan__seam');
            line.setAttribute('vector-effect', 'non-scaling-stroke');
            svg.appendChild(line);
          }
          var fs = Math.max(4, Math.min(baseFont, wPart * 0.7));
          var badge = document.createElementNS(SVG_NS, 'circle');
          badge.setAttribute('cx', x0 + wPart / 2);
          badge.setAttribute('cy', baseFont * 1.05);
          badge.setAttribute('r', fs * 0.72);
          badge.setAttribute('class', 'mp-plan__badge');
          svg.appendChild(badge);
          var tx = document.createElementNS(SVG_NS, 'text');
          tx.setAttribute('x', x0 + wPart / 2);
          tx.setAttribute('y', baseFont * 1.05);
          tx.setAttribute('font-size', fs);
          tx.setAttribute('text-anchor', 'middle');
          tx.setAttribute('dominant-baseline', 'central');
          tx.setAttribute('class', 'mp-plan__num');
          tx.textContent = String(i + 1);
          svg.appendChild(tx);
          x0 += wPart;
        }
        var border = document.createElementNS(SVG_NS, 'rect');
        border.setAttribute('width', W); border.setAttribute('height', H);
        border.setAttribute('class', 'mp-plan__border');
        border.setAttribute('vector-effect', 'non-scaling-stroke');
        svg.appendChild(border);
        this.el.plan.replaceChildren(svg);
        this._svg = svg;
        this.el.plan.style.aspectRatio = W + ' / ' + H;
      }
      this.positionPlanImage();
      var t = this.cfg.text;
      var txt = fill(st.count === 1 ? t.stripsEqualOne : t.stripsEqual, { n_les: st.count, largeur_le: fmtCm(st.stripWidthCm), hauteur: fmtCm(st.heightCm), largeur_max: st.maxStripCm });
      // conseil de pose : un lé d'1 m de large ou plus se pose à deux
      if (st.stripWidthCm >= 100 && t.stripsWide) txt += ' ' + t.stripsWide;
      if (this.state.spare) txt += ' ' + fill(t.spareLine, { largeur_le: fmtCm(st.stripWidthCm), hauteur: fmtCm(st.heightCm) });
      this.el.planText.textContent = txt;
    }

    positionPlanImage() {
      var f = this.frame;
      if (!f) return;
      var W = this.state.width;
      if (this._planPattern) {
        // décalage de la mosaïque : position du cadre dans la scène, en centimètres
        var ph = this.cfg.physical;
        this._planPattern.setAttribute('x', (-(f.x % 1) * Number(ph.widthCm)).toFixed(2));
        this._planPattern.setAttribute('y', (-(f.y % 1) * Number(ph.heightCm)).toFixed(2));
        return;
      }
      var img = this._planImg;
      if (!img) return;
      var fullW = W / f.fw;
      var fullH = this.physical
        ? fullW * Number(this.cfg.physical.heightCm) / Number(this.cfg.physical.widthCm)
        : fullW / (this.art().w / this.art().h);
      img.setAttribute('width', fullW.toFixed(3));
      img.setAttribute('height', fullH.toFixed(3));
      img.setAttribute('x', (-f.x * fullW).toFixed(3));
      img.setAttribute('y', (-f.y * fullH).toFixed(3));
    }

    /* ---------- Livraison estimée ---------- */

    renderDelivery() {
      var d = this.cfg.delivery;
      if (!d || !d.show || !this.el.delivery) return;
      var fmt = new Intl.DateTimeFormat('fr-FR', { weekday: 'long', day: 'numeric', month: 'long' });
      var now = new Date();
      this.el.deliveryText.textContent = fill(this.cfg.text.deliveryText, {
        date_min: fmt.format(addBusinessDays(now, Number(d.minDays) || 5)),
        date_max: fmt.format(addBusinessDays(now, Number(d.maxDays) || 10)),
      });
      this.el.delivery.hidden = false;
    }

    /* ---------- Panier ---------- */

    lineProperties() {
      var s = this.state;
      var q = this.plan.quote;
      var st = q.strips;
      var P = this.P;
      var mat = this.material();
      var tintLabel = this.cfg.tints[s.tint] || s.tint;
      var les = st.count + (st.count > 1 ? ' lés égaux de ' : ' lé de ') + fmtCm(st.stripWidthCm) + ' cm';
      var props = {
        [K('Motif')]: this.cfg.product.title,
        [K('Dimensions du mur')]: fmtCm(s.width) + ' × ' + fmtCm(s.height) + ' cm',
        [K('Surface facturée')]: q.minimumApplied
          ? 'minimum de commande ' + P.formatEuros(q.minimumCents) + ' (surface ' + P.formatM2(q.surfaceM2) + ')'
          : P.formatM2(q.billedM2),
        [K('Matière')]: mat ? mat.label : s.material,
        [K('Version')]: tintLabel,
        [K('Lés')]: les,
        [K('Impression')]: 'après validation de votre plan coté',
        '_mp_wall': '1',
        '_mp_mode': this.plan.mode,
        '_motif_url': this.cfg.product.url,
        '_motif_variant': String(this.P.motifVariant(this.cfg.product.variants, s.material, s.tint) || this.cfg.product.variantId),
        '_image': this.cfg.product.image || '',
        '_prix_affiche': String(q.totalCents),
      };
      if (s.spare) props[K('Lé de rechange')] = '1 lé de ' + fmtCm(st.stripWidthCm) + ' × ' + fmtCm(s.height) + ' cm, même motif';
      var obs = this.el.obstacles && this.el.obstacles.value.trim();
      if (obs) props[K('Fenêtre, porte, prise')] = obs.slice(0, 500);
      if (this.frame) {
        var f = this.frame;
        var view = this.view || { vw: 1, vh: 1 };
        props[K('Cadrage')] = this.cfg.text.cadragePublic;
        if (this.repeat) {
          var ph = this.cfg.physical;
          props['_cadrage_detail'] = 'motif répété, décalage ' + fmtCm((f.x % 1) * ph.widthCm) + ' cm en largeur et ' + fmtCm((f.y % 1) * ph.heightCm) + ' cm en hauteur';
          props['_cadrage'] = JSON.stringify({ repeat: true, dx_cm: +((f.x % 1) * ph.widthCm).toFixed(1), dy_cm: +((f.y % 1) * ph.heightCm).toFixed(1) });
        } else {
          props['_cadrage_detail'] = 'centre à ' + pct(f.x + f.fw / 2) + ' de la largeur et ' + pct(f.y + f.fh / 2) +
            ' de la hauteur de l\'œuvre, zoom ' + s.zoom.toFixed(2).replace('.', ',');
          props['_cadrage'] = JSON.stringify({ x: +f.x.toFixed(4), y: +f.y.toFixed(4), fw: +f.fw.toFixed(4), fh: +f.fh.toFixed(4) });
        }
        void view;
      }
      return props;
    }

    async postCart(items) {
      var drawer = document.querySelector('cart-drawer');
      var body = { items: items };
      if (drawer) {
        body.sections = 'cart-drawer,cart-icon-bubble';
        body.sections_url = window.location.pathname;
      }
      var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      var res = await fetch(root + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: JSON.stringify(body),
      });
      var data = await res.json().catch(function () { return {}; });
      if (!res.ok || data.status) {
        var err = new Error(data.description || data.message || 'cart_error');
        err.data = data;
        throw err;
      }
      if (drawer && data.sections && typeof drawer.renderContents === 'function') {
        drawer.renderContents(data);
        if (drawer.classList.contains('is-empty')) drawer.classList.remove('is-empty');
      } else if (this.dataset.cartType !== 'drawer' || !drawer) {
        window.location.href = (window.routes && window.routes.cart_url) || '/cart';
      }
      if (typeof window.publish === 'function' && window.PUB_SUB_EVENTS) {
        window.publish(window.PUB_SUB_EVENTS.cartUpdate, { source: 'mp-configurator', cartData: data });
      }
      return data;
    }

    async addToCart() {
      if (this._busy) return;
      // Recalcul juste avant l'ajout : rien ne part si le prix affiché n'est pas celui de la ligne.
      if (this.dimsValid) this.update({});
      if (this.el.add.disabled) return;
      var line = this.plan.line;
      if (!line.ok || line.lineCents !== this.plan.quote.totalCents) return;
      var items = [{ id: line.id, quantity: line.quantity, properties: this.lineProperties() }];
      this._busy = true;
      this.el.add.setAttribute('aria-busy', 'true');
      this.el.add.classList.add('is-loading');
      this.setStatus(this.cfg.text.adding, '');
      try {
        await this.postCart(items);
        this.setStatus(this.cfg.text.added, 'ok');
      } catch (e) {
        console.error('[mp-configurator] ajout au panier', e);
        this.setStatus((e.data && e.data.description) || this.cfg.text.cartError, 'error');
      } finally {
        this._busy = false;
        this.el.add.removeAttribute('aria-busy');
        this.el.add.classList.remove('is-loading');
      }
    }

    async addSample(kind, button) {
      var extra = this.cfg.extras && this.cfg.extras[kind];
      if (!extra) return;
      var s = this.state;
      var props = {
        [K('Motif')]: this.cfg.product.title,
        [K('Version')]: this.cfg.tints[s.tint] || s.tint,
        '_motif_url': this.cfg.product.url,
        '_image': this.cfg.product.image || '',
      };
      if (kind === 'strip') {
        var mat = this.material();
        props[K('Matière')] = mat ? mat.label : s.material;
        props[K('À l\'échelle du mur')] = fmtCm(s.width) + ' × ' + fmtCm(s.height) + ' cm';
        if (this.frame) props['_cadrage'] = JSON.stringify({ x: +this.frame.x.toFixed(4), y: +this.frame.y.toFixed(4), fw: +this.frame.fw.toFixed(4) });
      }
      button.disabled = true;
      try {
        await this.postCart([{ id: extra.id, quantity: 1, properties: props }]);
        this.setStatus(this.cfg.text.sampleAdded, 'ok');
      } catch (e) {
        this.setStatus(this.cfg.text.cartError, 'error');
      } finally {
        button.disabled = false;
      }
    }

    /* ---------- Barre mobile ---------- */

    /** Libellé et message de la barre collante : toujours alignés sur le bouton principal. */
    refreshSticky(ok) {
      var sticky = this.sticky;
      if (!sticky) return;
      var cta = sticky.querySelector('[data-sticky-cta]');
      var msg = sticky.querySelector('[data-sticky-msg]');
      var t = this.cfg.text;
      if (cta) {
        cta.textContent = this.state.touched ? t.cta : t.stickyConfigure;
        // 29/10 : ajout refusé → bouton atténué comme le bouton principal ; le clic mène toujours au message
        cta.setAttribute('aria-disabled', this.state.touched && !ok ? 'true' : 'false');
      }
      if (msg) {
        var show = this.state.touched && !ok && !!this.blockedMsg;
        msg.hidden = !show;
        msg.textContent = show ? t.stickyBlocked : '';
      }
    }

    setupSticky() {
      var sticky = this.sticky;
      if (!sticky || !('IntersectionObserver' in window)) return;
      var self = this;
      var cta = sticky.querySelector('[data-sticky-cta]');
      var dims = this.el.width;
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) { sticky.hidden = en.isIntersecting; });
      }, { threshold: 0 });
      io.observe(this.el.add);
      this.refreshSticky(!this.el.add.disabled);
      cta.addEventListener('click', function () {
        if (!self.state.touched) {
          dims.scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth', block: 'center' });
          dims.focus({ preventScroll: true });
          return;
        }
        if (self.el.add.disabled) {
          // ajout refusé : on montre le message et ses issues, au-dessus du bouton principal
          var target = (self.el.block && !self.el.block.hidden) ? self.el.block : self.el.add;
          target.scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth', block: 'center' });
          if (target === self.el.block) target.focus({ preventScroll: true });
          return;
        }
        self.addToCart();
      });
    }
  }

  customElements.define('mp-configurator', MpConfigurator);
})();
